import {
  InspectorControls,
  useBlockProps,
  useInnerBlocksProps,
  store as blockEditorStore,
} from "@wordpress/block-editor";
import { useEffect } from "@wordpress/element";
import { useDispatch } from "@wordpress/data";
import { useInstanceId } from "@wordpress/compose";

import PostsInspectorControls from "./InspectorControls";

// Default inner template: a single post-template child that holds the per-post
// card layout authored by the admin.
const TEMPLATE = [["brandy/posts-template", {}]];

export default function Edit(props) {
  const { attributes, setAttributes } = props;

  const blockProps = useBlockProps();
  const { __unstableMarkNextChangeAsNotPersistent } =
    useDispatch(blockEditorStore);

  const instanceId = useInstanceId(Edit);

  const innerBlocksProps = useInnerBlocksProps(blockProps, {
    template: TEMPLATE,
    templateLock: false,
  });

  const { queryId } = attributes;

  // Assign a stable queryId once, without polluting the undo history. Core's
  // pagination blocks key their `query-{id}-page` parameter on it, so two
  // loops on one page have to disagree about their ids.
  useEffect(() => {
    if (!Number.isFinite(queryId)) {
      __unstableMarkNextChangeAsNotPersistent();
      setAttributes({ queryId: instanceId });
    }
  }, [queryId, instanceId]);

  return (
    <>
      <InspectorControls>
        <PostsInspectorControls
          attributes={attributes}
          setAttributes={setAttributes}
        />
      </InspectorControls>
      <div {...innerBlocksProps} />
    </>
  );
}
